import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryMenuItemTitle } from '../../component';
import { ColorPickerWithUndoRedoSection } from '../../component/ColorPickerWithundoRedoSection';

interface PageSetupViewProps {
  backgroundColor: string;
  onColorChange: (color: string) => void;
  onOpen?: () => void;
  onClose: (color: string) => void;
  marginsSlot: ReactNode;
  orientationSlot?: ReactNode;
}

export function PageSetupView({ backgroundColor, onColorChange, onOpen, onClose, marginsSlot, orientationSlot }: PageSetupViewProps) {
  const { t } = useTranslation();

  return (
    <Stack gap={1.5} pb={6}>
      <Stack>
        <ColorPickerWithUndoRedoSection
          title={t('editor.side_panel.background')}
          currentColor={backgroundColor}
          onColorChange={onColorChange}
          onOpen={onOpen}
          onClose={onClose}
        />
      </Stack>
      {orientationSlot}
      <Stack gap={1.5} width="100%">
        <SecondaryMenuItemTitle>{t('editor.side_panel.margins')}</SecondaryMenuItemTitle>
        <Grid container alignItems="center" justifyContent="start">
          {marginsSlot}
        </Grid>
      </Stack>
    </Stack>
  );
}
